import axios from 'axios'
import {base_api} from './base'

export function login(data) {
  return axios.post(`${base_api}/Token/LoginToken`, data, {headers: {'Content-Type': 'application/json'}});
}

export function apiLogin(data) {
  return axios.post(`${base_api}/Token/SSOLogin`, data, {headers: {'Content-Type': 'application/json'}});
}

export function clientLogin(licenseKey) {
  const param = {key: licenseKey};
  return axios.post(`${base_api}/Token/clientToken`, null, {headers: param});
}

export function refresh(token) {
  const param = {token: token};
  return axios.post(`${base_api}/Token/Refresh`, null, {headers: param});
}

export function logout(token) {
  const param = {token: token};
  return axios.post(`${base_api}/Token/LogOut`, null, {headers: param});
}

export function apiLogout(token) {
  const param = {token: token};
  return axios.post(`${base_api}/Token/APILogOut`, null, {headers: param});
}

export function licenseLogout(licenseKey) {
  const param = {licenseKey: licenseKey};
  return axios.post(`${base_api}/Token/LicenseLogOut`, null, {headers: param});
}

export function setSession(token, username) {
  localStorage.setItem('username', username);
  localStorage.setItem('fullName', '');
  localStorage.setItem('is_authenticated', 'true');
  localStorage.setItem('userId', token.userId);
  localStorage.setItem('authToken', token.accessToken);
  localStorage.setItem('refreshToken', token.refreshToken);
  localStorage.setItem('tokenExpiration', token.tokenExpiration);
  localStorage.setItem('selected_event', 0);
}

export function removeSession() {
  let token = localStorage.getItem('refreshToken');
  logout(token);
  let rememberUser = localStorage.getItem('rememberUser');
  let userName = localStorage.getItem('username');
  if (localStorage.getItem('API_Query')) {
    apiLogout(token);
  }
  localStorage.clear();
  sessionStorage.clear();

  localStorage.setItem('rememberUser', rememberUser);
  if (rememberUser == "true") {
    localStorage.setItem('username', userName);
  }
}

export function isAuthenticated() {
  let authenticated = false;
  const isAuthenticated = localStorage.getItem('is_authenticated');
  if (isAuthenticated) {
    authenticated = true;
  } else {
    authenticated = false;
  }
  return authenticated
}



// WEBPACK FOOTER //
// ./src/services/Authentication.service.js